export default __webpack_public_path__ + "static/media/reliance.70b26c6a.png";